import "./basket-icon.styles.css";

export default function BasketIcon() {
  return (
    <lord-icon
      class="basket-icon"
      src="https://cdn.lordicon.com/dnoiydox.json"
      trigger="morph"
      colors="primary:#515151,secondary:#a6cdde"
    />
  );
}
